import { ITreatmentBeforeOperationCabergoline } from './TreatmentBeforeOperationCabergoline.types';

export const initialTreatmentBeforeOperationCabergoline: ITreatmentBeforeOperationCabergoline = {
  dose: '',
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}